import { Feature } from '../../../../common/models/usermanagement.model';

export class ViewTogglerHelper {
  static toggleDataBlock(comp: any, block: string, chatBlock?: any): void {
    const target = chatBlock || comp;
    comp.resetChartStates('table', chatBlock);
    target.isLineChartClick = false;
    target.displayTable = true;
    const rowdata = comp.dataObject['Row'];
    const columndata = comp.dataObject['Column'];
    const rowDataLength: number = rowdata.length > 0 ? rowdata[0].Data.length : 0;
    target.DefaultDataDropDown = block;
    comp.updateChartDisablingFlags(chatBlock);
    target.dataDropDown = false;
    if (block === 'Data') {
      target.isData = true;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Sample Size') {
      target.isData = false;
      target.isSampleSize = true;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Sample') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = true;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Weighted Numerator') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = true;
      target.isUnWeightedNumerator = false;
    } else if (block === 'Unweighted Numerator') {
      target.isData = false;
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = true;
    }

    if (target.isIndex) {
      target.isChartView = false;
    }
  }

  static toggleSigBlock(comp: any, blockName: string, chatBlock?: any): void {
    const target = chatBlock || comp;
    if (blockName === 'Sig') {
      target.isSig = true;
      target.isIndex = false;
      comp.updateChartDisablingFlags(chatBlock);
      target.isSampleSize = false;
      target.isWeightedLabel = false;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
      comp.resetChartStates('table', chatBlock);
      comp.is_Time_Period_Present = true;

      if (comp.mcode == 3 && comp.lastCrosstabPayload) {
        comp.callSignificancePayloadService("None", comp.lastCrosstabPayload, target);
      } else if (comp.mcode == 2 && comp.lastBrandAnalysisPayload) {
        comp.callBrandAnalysisPayloadService("None", comp.lastBrandAnalysisPayload, target);
      } else {
        comp.createTable(false, Feature.CrosstabOutput, false, chatBlock);
      }
    } else if (blockName === 'Index') {
      comp.displayTable = true;
      comp.isData = true;
      target.isWeightedNumerator = false;
      target.isUnWeightedNumerator = false;
      comp.DefaultDataDropDown = 'Data';
      comp.resetChartStates('table', chatBlock);
      target.isSig = false;
      target.isIndex = true;
      target.isChartView = false;
      target.disableStackChart = true;
      target.disableLineChart = true;
      target.DefaultReferenceLevel = 'None';
      target.DefaultSampleSize = 'None';
      target.DefaultConfidenceLevel = 'None';
      target.SignificanceVsReference = '';
      target.isReference = false;
      target.selectedIndex = '';
      target.isPairWise = false;
      if (target.isTranspose) {
        target.isTranspose = false;
        comp.reverseTranspose();
      }
      target.IndexData = comp.getLastLevelColumnNestingValues(target);
    }
    target.sampleSizeDropdown = false;
  }

  static toggleStarred(comp: any, chat: { question: string, response: string, messageId?: string, isStarred?: boolean, isLiked?: boolean | null, dislikeReason?: string }) {
    if (!chat.messageId || !comp.selectedChatId) {
      console.warn('[toggleStarred] ❌ Missing messageId or selectedChatId');
      comp.showToast('Cannot star: Message ID is not available', 'error');
      return;
    }

    const newStarredState = !chat.isStarred;
    comp.apiService.updateChatStarred(chat.messageId, newStarredState).subscribe({
      next: (res: string) => {
        const apiResponse = JSON.parse(res);
        if (apiResponse.HasValidData) {
          chat.isStarred = newStarredState;
          comp.showToast(newStarredState ? 'Message starred successfully' : 'Message unstarred successfully', 'success');

          if (!newStarredState) {
            const beforeCount = comp.starredMessages.length;
            comp.starredMessages = comp.starredMessages.filter((m: any) => {
              const mId = (m.MessageId || (m as any).messageId || '').toString().toLowerCase();
              const targetId = (chat.messageId || '').toString().toLowerCase();
              return mId !== targetId;
            });
            comp.onStarredSearch();
          } else {
            comp.loadStarredMessages();
          }

          if (chat.messageId && comp.selectedChatId) {
            const chatInList = comp.allChatList.find((c: any) => c.ChatId === comp.selectedChatId);
            if (chatInList && chatInList.ChatHistory) {
              const msg = chatInList.ChatHistory.find((h: any) => h.MessageId === chat.messageId);
              if (msg) {
                msg.IsStarred = newStarredState;
                (msg as any).isStarred = newStarredState;
              }
            }
          }
        } else {
          comp.showToast('Failed to update starred status', 'error');
        }
      },
      error: (err: any) => {
        comp.showToast('Error while updating starred status', 'error');
      }
    });
  }

  static onTrendToggle(comp: any, block: any) {
    if (!block) return;

    block.isTrendActive = !block.isTrendActive;
    comp.isSampleSize = false;

    // Sync global state and update insights only if this is the currently selected active message
    if (block.messageId === comp.selectedMessageId) {
      comp.isTrendActive = block.isTrendActive;
      const targetText = comp.isTrendActive ? comp.snapshotinsights_trendline_text : comp.snapshotinsights_standard_text;
      if (targetText) {
        comp.insightsStreamingText = targetText;
        comp.insightsStreamingPoints = comp.formatInsightsIntoPoints(targetText);

        comp.InsightsResponse = {
          header: comp.isTrendActive ? 'Trendline Insights' : 'Snapshot Insights',
          message: targetText,
          show: true
        };
        comp._insightsSerive.showInisghts(comp.InsightsResponse);
      }
    }
  }

  static isInsightVisible(comp: any, block: any): boolean {
    const hasData = !!(block.insights && block.insights.length > 0) ||
      !!(block.insightsTrend && block.insightsTrend.length > 0) ||
      !!(block.analyticalData?.Insights && Array.isArray(block.analyticalData.Insights) && block.analyticalData.Insights.length > 0);

    const isVisible = (block.messageId === comp.selectedMessageId && comp.selectedMessageId !== null)
      ? (comp.isInsightspopupOpen || hasData)
      : hasData;

    return isVisible;
  }

  static isSnapshotVisible(comp: any, block: any): boolean {
    const mcode = comp.getMcode(block);

    // For active message, respect the global showSnapshot flag but only if it's actually mcode 1
    if (block.messageId === comp.selectedMessageId && comp.selectedMessageId !== null) {
      return comp.showSnapshot && mcode === 1;
    }

    // For historical messages, mcode is the definitive indicator
    if (mcode === 1) return true;
    if (mcode === 2 || mcode === 3) return false;

    const analytical = block.analyticalData || block.parsedData;
    return !!(
      block.fullAnswer?.getSnapshotConfiguration ||
      block.fullAnswer?.GetCustomSnapshotWidget ||
      analytical?.getSnapshotConfiguration ||
      analytical?.GetCustomSnapshotWidget
    );
  }
}
